export const drc_logos = {
  drc_logo_blue: require('./drc-logo-blue.svg'),
  drc_logo_yellow: require('./drc-logo-yellow.svg'),
  drc_logo_salmon: require('./drc-logo-yellow.svg'),
  drc_bg_login: require('./drc-bg_login-b2b_2x.png'),
}
